import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfDemandService, ModelOfService, ModelOfServiceOrderType } from '../../database';
import { useFormik } from 'formik';
import api from '../../services/api';
import * as Yup from 'yup';
import { useData } from 'src/contexts/data';
import { useHistory } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import moment from 'moment';

interface PersonCpfProps {
	PESSOA: string;
	NOME: string;
	DATANASCIMENTO: string;
}

export const useFormCreateOrderService = () => {
	const { userId, userAgencyId } = useAuth();
	const { selectedDemand, selectedOrderService } = useData();
	const [loading, setLoading] = useState(false);
	const [loadingServiceTypes, setLoadingServiceTypes] = useState(false);
	const [loadingServices, setLoadingServices] = useState(false);
	const [formDialog, setFormDialog] = useState(false);
	const [selectedField, setSelectedField] = useState('');

	const [serviceResponse, setServiceResponse] = useState<AxiosResponse | null>(null);
	const [serviceOrderTypeResponse, setServiceOrderTypeResponse] = useState<AxiosResponse | null>(null);
	const [serviceOrderTypeData, setServiceOrderTypeData] = useState<ModelOfServiceOrderType[]>([]);
	const [ProductData, setProductData] = useState<any[]>([]);
	const [ServiceData, setServiceData] = useState<any[]>([]);
	const [productList, setProductList] = useState<any[]>([]);
	const [serviceList, setServiceList] = useState<any[]>([]);
	const [PriorityData, setPriorityData] = useState<any[]>([]);

	const [PersonCpf, setPersonCpf] = useState<PersonCpfProps[]>([{ PESSOA: '', NOME: '', DATANASCIMENTO: '' }]);
	const [loadingPersonCpf, setLoadingPersonCpf] = useState(false);
	const [foundPersonCpf, setFoundPersonCpf] = useState(false);

	const toast: any = useRef();
	const history = useHistory();

	const validationSchemaNew = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
		FT_VEICULO: Yup.string().required('* Campo obrigatório'),
		ORGAOUNIDADEDESTINO: Yup.string().required('* Campo obrigatório'),
		PRIORIDADE: Yup.string().required('* Campo obrigatório'),
		VEICULOKM: Yup.string().required('* Campo obrigatório'),
		TIPOORDEMSERVICO: Yup.string().required('* Campo obrigatório'),
		PESSOAORIGEM: Yup.string().required('* Campo obrigatório'),
		PESSOADESTINO: Yup.string().required('* Campo obrigatório'),
	});

	const validationSchema = Yup.object().shape({
		VEICULOKM: Yup.string().required('* Campo obrigatório'),
		TIPOORDEMSERVICO: Yup.string().required('* Campo obrigatório'),
	});

	const validationSchemaServiceType = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getServiceOrderType = async () => {
		const response = await api.get('order-service-type');
		setServiceOrderTypeData(response.data);
	};

	const getProduct = async () => {
		const response = await api.get(`products/${userAgencyId}`);
		setProductData(response.data);
	};

	const getService = async () => {
		const response = await api.get(`services/${userAgencyId}`);
		setServiceData(response.data);
	};

	const getPriority = async () => {
		const response = await api.get(`prioritys`);
		setPriorityData(response.data);
	};

	const openFormDialog = async (field: string) => {
		setFormDialog(true);
		setSelectedField(field);
	};

	const closeFormDialog = () => {
		setFormDialog(false);
		setSelectedField('');
	};

	const createService = (Service: ModelOfService) => {
		setLoadingServices(true);

		const newService: ModelOfService = {
			DESCRICAO: Service.DESCRICAO,
			ORGAO: userAgencyId,
			VALOR: Service.VALOR,
		};

		api.post('/services', newService)
			.then((response) => {
				setServiceResponse(response);
				setLoadingServices(false);
				toast.current.show({
					severity: 'success',
					summary: 'Cadastro realizado',
					detail: 'Serviço criado com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				setLoadingServices(false);
				console.log(err);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao criar serviço.',
					life: 5000,
				});
			});
	};

	const createOrderServiceType = (orderServiceType: ModelOfServiceOrderType) => {
		console.log("Vai cadastrar a ordem de servico-->: ", orderServiceType)
		setLoadingServiceTypes(true);

		const newOrderServiceType: ModelOfServiceOrderType = {
			DESCRICAO: orderServiceType.DESCRICAO,
			ORGAO: userAgencyId,
		};

		api.post('/order-service-type', newOrderServiceType)
			.then((response) => {
				setServiceOrderTypeResponse(response);
				setLoadingServiceTypes(false);
				toast.current.show({
					severity: 'success',
					summary: 'Cadastro realizado',
					detail: 'Tipo de manutenção criado com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				setLoadingServiceTypes(false);
				console.log(err);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao criar tipo de manutenção.',
					life: 5000,
				});
			});
	};

	const createOrderService = (orderService: ModelOfDemandService) => {
		setLoading(true);

		const newServiceList = serviceList.map((service) => {
			return {
				FT_SERVICO: service.FT_SERVICO,
				QUANTIDADE_SERVICO: service.QUANTIDADE_SERVICO,
			};
		});
		const newProductList = productList.map((product) => {
			return {
				AX_PRODUTO: product.AX_PRODUTO,
				QUANTIDADE_PRODUTO: product.QUANTIDADE_PRODUTO,
			};
		});

		let status = 0;

		const newOrderService: ModelOfDemandService = {
			ORGAO: userAgencyId,
			FT_USUARIO: userId,
			STATUS: status,
			SERVICOS: newServiceList,
			PRODUTOS: newProductList,
			VEICULOKM: orderService.VEICULOKM?.replace(',', '.'),
			TIPOORDEMSERVICO: orderService.TIPOORDEMSERVICO,
		};

		api.post('/services-order', { ...newOrderService, DEMANDA: selectedDemand.ID })
			.then((response) => {
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Cadastro realizado',
					detail: 'Ordem de serviço criada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					history.push('/orderServiceList');
				}, 1000);
			})
			.catch((err) => {
				setLoading(false);
				console.log(err);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao criar ordem de serviço.',
					life: 5000,
				});
			});
	};

	const createNewOrderService = (orderService: ModelOfDemandService) => {
		console.log("Vai cadastrar a ordem de servico aqui: ", orderService)
		setLoading(true);

		console.log(" ---> serviceList: ",serviceList)

		const newServiceList = serviceList.map((service) => {
			return {
				FT_SERVICO: service.FT_SERVICO,
				QUANTIDADE_SERVICO: service.QUANTIDADE_SERVICO,
			};
		});
		const newProductList = productList.map((product) => {
			return {
				AX_PRODUTO: product.AX_PRODUTO,
				QUANTIDADE_PRODUTO: product.QUANTIDADE_PRODUTO,
			};
		});

		let status = 0;

		const newOrderService: ModelOfDemandService = {
			ORGAO: userAgencyId,
			FT_USUARIO: userId,
			STATUS: status,
			SERVICOS: newServiceList,
			PRODUTOS: newProductList,
			VEICULOKM: orderService.VEICULOKM?.replace(',', '.'),
			TIPOORDEMSERVICO: orderService.TIPOORDEMSERVICO,
		};

		console.log("  ---> newOrderService: ",newOrderService)

		const newDemand = {
			ORGAO: userAgencyId,
			DESCRICAO: orderService.DESCRICAO,
			PESSOAORIGEM: orderService.PESSOAORIGEM,
			PESSOADESTINO: orderService.PESSOADESTINO,
			ORGAOUNIDADEDESTINO: orderService.ORGAOUNIDADEDESTINO,
			PRIORIDADE: orderService.PRIORIDADE,
			TIPODEMANDA: 1,
			FT_USUARIO: userId,
			FT_VEICULO: orderService.FT_VEICULO,
		};

		console.log("  ---> newDemand: ",newDemand)

		api.post('demands', newDemand)
			.then((responseDemand) => {
				let demandId = responseDemand.data.ID;
				api.post('/services-order', { ...newOrderService, DEMANDA: demandId })
					.then((response) => {
						setLoading(false);
						toast.current.show({
							severity: 'success',
							summary: 'Cadastro realizado',
							detail: 'Ordem de serviço criada com sucesso!',
							life: 5000,
						});
						setTimeout(() => {
							history.push('/orderServiceList');
						}, 1000);
					})
					.catch((err) => {
						setLoading(false);
						console.log(err);
						toast.current.show({
							severity: 'error',
							summary: 'Cadastro não realizado',
							detail: 'Falha ao criar ordem de serviço.',
							life: 5000,
						});
					});
			})
			.catch((err) => {
				setLoading(false);
				console.log(err);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao criar ordem de serviço.',
					life: 5000,
				});
			});
	};

	const editOrderService = (orderService: ModelOfDemandService) => {
		setLoading(true);

		const newServiceList = serviceList.map((service) => {
			return {
				FT_SERVICO: service.FT_SERVICO,
				QUANTIDADE_SERVICO: service.QUANTIDADE_SERVICO,
			};
		});
		const newProductList = productList.map((product) => {
			return {
				AX_PRODUTO: product.AX_PRODUTO,
				QUANTIDADE_PRODUTO: product.QUANTIDADE_PRODUTO,
			};
		});

		let status = 1;

		const newOrderService: ModelOfDemandService = {
			DEMANDA: selectedOrderService.DEMANDA,
			ORGAO: userAgencyId,
			FT_USUARIO: userId,
			STATUS: status,
			SERVICOS: newServiceList,
			PRODUTOS: newProductList,
			VEICULOKM: orderService.VEICULOKM?.toString()?.replace(',', '.'),
			TIPOORDEMSERVICO: orderService.TIPOORDEMSERVICO,
			DATA: selectedOrderService.DATA_ORDEMSERVICO,
			DATAEFETIVADA: moment(orderService.DATAEFETIVADA, 'DD/MM/YYYY').toDate().toLocaleDateString('en', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}),
		};
		console.log("vai criar alterar a ordem de servico")
		api.put(`/services-order/${selectedOrderService.ID}`, newOrderService)
			.then((response) => {
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Conclusão realizada',
					detail: 'Ordem de serviço finalizada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					history.push('/finishOrderServiceList');
				}, 1000);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Conclusão não realizada',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const removeProduct = (product: any) => {
		const productFilter = productList.filter((element: any) => element.AX_PRODUTO !== product.AX_PRODUTO);
		setProductList(productFilter);
	};

	const removeService = (service: any) => {
		const serviceFilter = serviceList.filter((element: any) => element.FT_SERVICO !== service.FT_SERVICO);
		setServiceList(serviceFilter);
	};

	const reduceProduct = (product: any) => {
		const updateList = productList.map((element: any, index: any) => {
			if (element.AX_PRODUTO === product.AX_PRODUTO) {
				let newObj = {
					...element,
					QUANTIDADE_PRODUTO: element.QUANTIDADE_PRODUTO - 1,
				};
				let conta = element.VALOR_PRODUTOBASE * newObj.QUANTIDADE_PRODUTO;
				let arredondado = parseFloat(conta.toFixed(2));
				newObj.VALOR_PRODUTO = arredondado;

				return newObj;
			}
			return element;
		});

		const filterList = updateList.filter((element) => {
			return element.QUANTIDADE_PRODUTO !== 0;
		});

		setProductList(filterList);
	};

	const reduceService = (service: any) => {
		const updateList = serviceList.map((element: any, index: any) => {
			if (element.FT_SERVICO === service.FT_SERVICO) {
				let newObj = {
					...element,
					QUANTIDADE_SERVICO: element.QUANTIDADE_SERVICO - 1,
				};
				let conta = element.VALOR_SERVICOBASE * newObj.QUANTIDADE_SERVICO;
				let arredondado = parseFloat(conta.toFixed(2));
				newObj.VALOR_SERVICO = arredondado;
				return newObj;
			}
			return element;
		});

		const filterList = updateList.filter((element) => {
			return element.QUANTIDADE_SERVICO !== 0;
		});

		setServiceList(filterList);
	};

	const addServiceList = (service: any) => {
		const found = serviceList.find((element) => element.FT_SERVICO === service.FT_SERVICO);
		if (!found) {
			setServiceList([...serviceList, service]);
		} else {
			const updateList = serviceList.map((element: any) => {
				if (element.FT_SERVICO === service.FT_SERVICO) {
					let newObj = {
						...element,
						QUANTIDADE_SERVICO: element.QUANTIDADE_SERVICO + 1,
					};
					let conta = element.VALOR_SERVICOBASE * newObj.QUANTIDADE_SERVICO;
					let arredondado = parseFloat(conta.toFixed(2));
					newObj.VALOR_SERVICO = arredondado;
					return newObj;
				}
				return element;
			});

			setServiceList(updateList);
		}
	};

	const addProductList = (product: any) => {
		const found = productList.find((element) => element.AX_PRODUTO === product.AX_PRODUTO);

		if (!found) {
			setProductList([...productList, product]);
		} else {
			const updateList = productList.map((element: any) => {
				if (element.AX_PRODUTO === product.AX_PRODUTO) {
					let newObj = {
						...element,
						QUANTIDADE_PRODUTO: element.QUANTIDADE_PRODUTO + 1,
					};
					let conta = element.VALOR_PRODUTOBASE * newObj.QUANTIDADE_PRODUTO;
					let arredondado = parseFloat(conta.toFixed(2));
					newObj.VALOR_PRODUTO = arredondado;
					return newObj;
				}
				return element;
			});
			setProductList(updateList);
		}
	};

	useEffect(() => {
		getProduct();
		getService();
		getServiceOrderType();
		getPriority();
	}, []);

	const formikService = useFormik<ModelOfService>({
		initialValues: {
			DESCRICAO: '',
			ORGAO: '',
			VALOR: 0,
		},
		onSubmit: (values) => createService(values),
		validationSchema: validationSchemaServiceType,
	});

	const formikServiceType = useFormik<ModelOfServiceOrderType>({
		
		initialValues: {
			DESCRICAO: '',
			ORGAO: '',
		},
		onSubmit: async (values) => await createOrderServiceType(values),
		validationSchema: validationSchemaServiceType,
	});

	const formikCreateNew = useFormik<ModelOfDemandService>({
		initialValues: {
			DEMANDA: '',
			FT_USUARIO: '',
			STATUS: 0,
			VEICULOKM: '',
			ORGAO: '',
			TIPOORDEMSERVICO: '',
			SERVICOS: [],
			PRODUTOS: [],
			DESCRICAO: '',
			PESSOAORIGEM: '',
			PESSOADESTINO: '',
			ORGAOUNIDADEDESTINO: '',
			PRIORIDADE: '',
			TIPODEMANDA: 1,
			FT_VEICULO: '',
		},
		onSubmit: (values) => createNewOrderService(values),
		validationSchema: validationSchemaNew,
	});

	const formikCreate = useFormik<ModelOfDemandService>({
		initialValues: {
			DEMANDA: '',
			FT_USUARIO: '',
			STATUS: 0,
			VEICULOKM: '',
			ORGAO: '',
			TIPOORDEMSERVICO: '',
			SERVICOS: [],
			PRODUTOS: [],
		},
		onSubmit: (values) => createOrderService(values),
		validationSchema,
	});

	const formikEdit = useFormik<ModelOfDemandService>({
		initialValues: {
			DEMANDA: '',
			FT_USUARIO: '',
			STATUS: 0,
			VEICULOKM: '',
			ORGAO: '',
			DATAEFETIVADA: '',
			TIPOORDEMSERVICO: '',
			SERVICOS: [],
			PRODUTOS: [],
		},
		onSubmit: (values) => editOrderService(values),
		validationSchema,
	});

	const searchPersonCpf = async (cpf: string, field: string) => {
		setLoadingPersonCpf(true);
		const response = await api.post('people/get-person', { CPF: cpf });

		if (response.data.length) {
			setPersonCpf(response.data);
			formikCreateNew.setFieldValue(field, response.data[0].ID);
		}

		setFoundPersonCpf(!!response.data[0]);
		setLoadingPersonCpf(false);
	};

	return {
		getOrderServiceFormController: {
			formDialog,
			selectedField,
			formikCreateNew,
			formikCreate,
			formikEdit,
			formikServiceType,
			formikService,
			ProductData,
			ServiceData,
			productList,
			serviceList,
			loading,
			loadingServiceTypes,
			loadingServices,
			toast,
			serviceOrderTypeData,
			serviceOrderTypeResponse,
			serviceResponse,
			PriorityData,
			loadingPersonCpf,
			foundPersonCpf,
			PersonCpf,
		},

		handleOrderServiceFormController: {
			openFormDialog,
			closeFormDialog,
			removeProduct,
			removeService,
			addServiceList,
			addProductList,
			reduceService,
			reduceProduct,
			setProductList,
			setServiceList,
			searchPersonCpf,
			setFoundPersonCpf,
		},
	};
};
